import { render, staticRenderFns } from "./barChartForTask.vue?vue&type=template&id=a339237a&scoped=true"
import script from "./barChartForTask.vue?vue&type=script&lang=js"
export * from "./barChartForTask.vue?vue&type=script&lang=js"
import style0 from "./barChartForTask.vue?vue&type=style&index=0&id=a339237a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a339237a",
  null
  
)

export default component.exports